import React from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";

//
import Moment from "react-moment";
import ScrollBar from "react-perfect-scrollbar";
import NothingToShow from "../general/NothingToShow";

function MobileNotifications({ notifications, showModal }) {
  let navigate = useNavigate();

  return (
    <div className="mobile">
      <header>
        <i
          className="las la-angle-left pointer flex-grow-1"
          onClick={() => navigate(-1)}
        ></i>
        <h5 className="text-dark flex-grow-1 text-center">Notifications</h5>
        {notifications.length ? (
          <i
            className="lar la-trash-alt pointer flex-grow-1 text-end"
            onClick={showModal}
          ></i>
        ) : (
          <span className="flex-grow-1"></span>
        )}
      </header>
      {notifications.length ? (
        <ScrollBar>
          <div className="item">
            <p>Earlier</p>
            {/* <small className="fw-bolder text-info">Mark all as read</small> */}
          </div>
          {notifications.map((item, index) => (
            <div className="item" key={index}>
              <div className="title-box">
                <span
                  // className={`icon-box ${
                  //   item.title === "Reminder" ? "warning" : "success"
                  // }`}
                  className="icon-box warning"
                >
                  <i
                    className="las la-info-circle"
                    // className={`las ${
                    //   item.title === "Reminder" ? "la-info-circle" : "la-check"
                    // }`}
                  ></i>
                </span>
                <div>
                  {item.symbol ? (
                    <Link
                      to={`/app/coin-detail/${item.symbol}`}
                      className="fw-bolder"
                    >
                      {item.title}
                    </Link>
                  ) : (
                    <p className="fw-bolder text-dark">{item.title}</p>
                  )}
                  <small className="text-muted">{item.message}</small>
                </div>
              </div>

              <div className="time-box">
                <small>
                  <Moment utc fromNow>
                    {item.created_at}
                  </Moment>
                </small>
              </div>
            </div>
          ))}
        </ScrollBar>
      ) : (
        <NothingToShow text="Nothing to show" />
      )}
    </div>
  );
}

MobileNotifications.propTypes = {
  notifications: PropTypes.array.isRequired,
  showModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  notifications: state.userReducer.notifications,
});

export default connect(mapStateToProps)(MobileNotifications);
